import React, { useState } from 'react'
import NewActionButton from '../../../components/ActionButtons/NewActionButton';
import { filterButtonsContainer, filterCard, filterHeader, filterResetBtn, filterSubmitBtn } from '../../../common/cssclasses';
import { useTranslate } from '../../../components/TranslationText';
import NetaqInput from '../../../components/NetaqInput';

export default function SemenFilter() {
  const { translate } = useTranslate();
  const [searchForm, setSearchForm] = useState({
    horseName: '',
    priceFrom: null,
    priceTo: null,
  })

  const handleSubmit = () => { }
  const handleReset = () => { }
  const handleChange = (event) => {
    setSearchForm({
      ...searchForm,
      [event.target.name]: event.target.value
    })
  }

  return (
    <form
      className={filterCard}
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
      <h2 className={filterHeader}>{translate('web.advancedSearch', 'Advanced Search')}</h2>
      <div className="mb-form-group">
        <NetaqInput
          name={"horseName"}
          label={translate("web.horseName", "Horse Name | Number")}
          placeholder={translate("web.horseName", "Horse Name | Number")}
          type={"text"}
          value={searchForm?.horseName}
          onChange={handleChange}
        />
      </div>
      <div className="mb-form-group-last">
        <div className="row">
          <div className="col-6">
            <NetaqInput
              name={"priceFrom"}
              type={"number"}
              label={
                <>
                  {translate("web.price", "rank")} {translate("web.from", "From")}
                </>
              }
              placeholder={'1'}
              value={1}
              onChange={handleChange}

            />
          </div>
          <div className="col-6">
            <NetaqInput
              name={"priceTo"}
              type={"number"}
              label={
                <>
                  {translate("web.price", "showRange")} {translate("web.to", "To")}
                </>
              }
              placeholder={'10'}
              onChange={handleChange}
              value={10}
            />
          </div>
        </div>
      </div>



      <div className={filterButtonsContainer} >
        <div className={filterResetBtn}>
          <NewActionButton
            key={"reset"}
            isButton
            classNames="btn-outline-secondary"

            type={"reset"}
            text={translate('web.reset', 'Reset')}
          />
        </div>
        <div className={filterSubmitBtn}>
          <NewActionButton
            isButton
            classNames="btn-danger"
            text={translate("web.search", "Search")}
            key={"apply"}
            type={"submit"}
          />
        </div>
      </div>
    </form>
  )
}
